// extracted by mini-css-extract-plugin
module.exports = {"buildControls":"BuildControls_buildControls__3Iivh","OrderButton":"BuildControls_OrderButton__1qFfc","enable":"BuildControls_enable__1KQv6"};